import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core/";
import classnames from "classnames";

import { TableHeaderText, useListingTableStyles } from "./listing-table.styles";
import { makeKey } from "../../../utils/helpers";
import { IListingTable } from "./listing-table.types";
import { ListingTableRow } from "./listing-table-row/listing-table-row.component";
import { withShowIf } from "../../with-show-if/with-show-If.component";

export const ListingTable = withShowIf((props: IListingTable) => {
  const classes = useListingTableStyles();

  const className = props.className ?? "";
  const headers = props.headers ?? true;

  const containerClasses = classnames({
    [classes.tableContainer]: true,
    [className]: !!className,
  });

  return (
    <TableContainer className={containerClasses}>
      <Table>
        {headers && (
          <TableHead>
            <TableRow>
              {props.columns.map((col, ci) => {
                return (
                  <TableCell key={makeKey(col.label, ci)}>
                    {col.customComponent ?? <TableHeaderText>{col.label}</TableHeaderText>}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          <ListingTableRow
            close={props.close}
            columns={props.columns}
            dataList={props.dataList}
            noResultsMessage={props.noResultsMessage}
            link={props.link}
            minFirstColumnWidth={props.minFirstColumnWidth ? props.minFirstColumnWidth : "none"}
          />
        </TableBody>
      </Table>
    </TableContainer>
  );
});
